import React, { useEffect, useState } from "react";
import {useDispatch } from "react-redux";

const DocumentFormView = ({ fileData, pdf, pageNumber, jsonMetaData, blobBuffer}) => {
  const dispatch = useDispatch();
  let fileURL;
  if(blobBuffer){
     const buff = Buffer.from(blobBuffer);
    
     const file = new Blob([buff], { type: 'application/pdf' });

     console.log('file',file)
     fileURL = window.URL.createObjectURL(file);
  }

  /*      
  const scale = 1.5;
  const [canvasContext, setCanvasContext] = useState();
  useEffect(() => {
    (async () => {
      if (pdf?.img)
        await decodeImg(pdf)
      else
        await decodePdf(pdf);

     
    })();
  }, [pdf, pageNumber]);


  /**
 * @description Function getting canvas context
 * @param {Number} value accepting width and height
 * @returns return canvas context
 */
 /* const create2dContext = (width, height) => {
    const canvas = document.getElementById("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas.getContext("2d");
  };*/

  /**
   * @description Function to render PDF data over canvas
   * @returns return updated canvas
   */
  /*const decodePdf = async (pdf) => {

    const page = await pdf.getPage(parseInt(pageNumber));
    let currentPdfWidth = page.getViewport({ scale: scale }).width;
    const viewport = page.getViewport({ scale: scale });
    const { width, height } = viewport;
    let canvasContext = create2dContext(width, height);

    await page.render({ canvasContext, viewport }).promise;


    setCanvasContext(canvasContext);
  };*/






  /**
   * @description Function to render PNG/JPG data over canvas
   * @returns return updated canvas
   */
 /* const decodeImg = async (imgInst) => {
    const { width, height } = imgInst;
    let canvasContext = await create2dContext(width, height);
    canvasContext.drawImage(imgInst.img, 0, 0, width, height);

    setCanvasContext(canvasContext);
  }
  return (<> <canvas id="canvas"></canvas> </>); */


  return (<> <iframe src={`${fileURL}#view=FitH`} type="application/pdf" height="1000px" width="100%">
    </iframe></>);
};


export default DocumentFormView;
